enum AppointmentStatusEnum {
  'Aguardando pagamento' = 1,
  'Pago' = 2,
  'A caminho' = 3,
  'No local' = 4,
  'Em andamento' = 5,
  'Procedimento finalizado' = 6,
  'At. finalizado' = 7,
  'Cancelado' = -1,
  'Aguardando Pagamento Adicional' = -2,
  'Em análise de cancelamento' = -3,
  'Concluído sem atendimento' = -4,
};

export default AppointmentStatusEnum;
